<template>
  <div class="cover-detail__container">
    <div>
      <BaseButton
        text="Back to 'Property details'"
        flat
        ripple
        class="font-weight-semi-bold d-flex back-btn back-previous__btn-link pa-0 mb-sm-5"
        icon="mdi-chevron-left"
        color="#106175"
        small
        @click="backToPropertyDetail"
      />
      <div class="d-flex justify-space-between section-title">
        <h1 class="font-28 font-weight-bold black2-color mb-5">
          {{
            $vuetify.breakpoint.mobile
              ? "Choose your cover"
              : "Choose your cover levels"
          }}
        </h1>
        <BaseButton
          text="Save &amp; exit"
          flat
          depressed
          ripple
          class="font-weight-semi-bold d2c-save-exit mt-2 mr-2 py-3 d-flex"
          icon="mdi-content-save"
          color="#106175"
          small
          @click="saveAndExit"
        />
      </div>
      <p class="mb-5">
        You can choose to add optional extras to your policy to give you even
        more protection. Adding landlord’s emergency cover or legal expenses to
        your landlord’s insurance can be cheaper than getting them separately.
      </p>
    </div>

    <div class="mb-11" id="Buildings_Insurance">
      <h4 class="font-20 mb-2 mt-5" v-if="!$vuetify.breakpoint.mobile">
        Buildings Insurance
      </h4>
      <div class="border-r10 px-3 py-9 px-lg-10">
        <h4 class="font-20 mb-8" v-if="$vuetify.breakpoint.mobile">
          Buildings Insurance
        </h4>
        <p class="mb-4 font-18">
          <v-icon size="18" class="mr-1" color="#1d8649"
            >mdi-check-circle</v-icon
          >This policy provides
          <span class="font-weight-bold">£1,000,000 buildings cover</span> as
          standard.
        </p>
        <v-alert color="var(--blue-100)" class="mb-9">
          <div class="d-flex flex-no-wrap align-start">
            <v-icon color="var(--blue-500)">mdi-information</v-icon>
            <div class="note__wrapper ml-1">
              <span class="font-weight-bold">Note:</span> This amount must cover
              the cost of rebuilding your property.
            </div>
          </div>
        </v-alert>

        <div
          class="d-flex flex-column flex-lg-row align-xl-center"
          :class="$vuetify.breakpoint.mobile ? 'mb-9' : 'mb-11'"
        >
          <div
            class="flex-wrap mr-lg-2 flex-basis-58 left-panel__money-spinner"
          >
            <p class="font-18 font-weight-medium mb-0">
              Choose your buildings cover excess
              <v-icon
                v-if="$vuetify.breakpoint.mobile"
                color="#106175"
                size="15"
                class="text-cursor"
                @click="showModal('DialogLandLordsContentBuildingCoverExcess')"
                >mdi-help-circle</v-icon
              >
            </p>
            <p class="mb-0" v-if="!$vuetify.breakpoint.mobile">
              <v-icon
                color="#106175"
                class="text-cursor"
                size="15"
                @click="showModal('DialogLandLordsContentBuildingCoverExcess')"
                >mdi-help-circle</v-icon
              >
              <a
                class="align-self-start accent--text font-weight-semi-bold"
                href="javascript:"
                @click="showModal('DialogLandLordsContentBuildingCoverExcess')"
                >What amount is right for me?
              </a>
            </p>
          </div>
          <BaseMoneySpinner
            :minusDataUiid="'minusDataUiid_ExcessBuildings'"
            :plusDataUiid="'plusDataUiid_ExcessBuildings'"
            :inputDataUiid="'inputDataUiid_ExcessBuildings'"
            :small="$vuetify.breakpoint.lgAndUp ? true : false"
            :config="configExcess"
            v-model="form.excessBuildings.Value"
            class="mt-5 mt-xl-0 pa-0 flex-grow-1"
          />
        </div>

        <div class="d-flex flex-column flex-lg-row">
          <div class="d-flex flex-column left-panel__toggle-button">
            <p class="ma-0 pr-lg-6 pr-0 font-18 font-weight-medium">
              Would you like to add extra accidental damage cover for buildings?
              <v-icon
                v-if="$vuetify.breakpoint.mobile"
                color="#106175"
                size="15"
                class="text-cursor"
                @click="
                  showModal(
                    'DialogLandLordsContentBuildingExtraAccidentalCover'
                  )
                "
                >mdi-help-circle</v-icon
              >
            </p>
            <p class="mb-0" v-if="!$vuetify.breakpoint.mobile">
              <v-icon
                color="#106175"
                size="15"
                class="text-cursor"
                @click="
                  showModal(
                    'DialogLandLordsContentBuildingExtraAccidentalCover'
                  )
                "
                >mdi-help-circle</v-icon
              >
              <a
                class="align-self-start accent--text font-weight-semi-bold"
                href="javascript:"
                @click="
                  showModal(
                    'DialogLandLordsContentBuildingExtraAccidentalCover'
                  )
                "
                >What’s covered as standard?</a
              >
            </p>
          </div>
          <div
            class="col-lg-4 pa-0 d-flex align-center mt-5 mt-lg-0 ml-lg-auto toggle-button__wrapper"
          >
            <BaseToggleButton
              :toggleButtonText="{
                yesDataUiid: 'AccidentalDamageBuildings_Yes',
                noDataUiid: 'AccidentalDamageBuildings_No',
              }"
              v-model="form.accidentalDamageBuildings.Value"
              :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mb-8" id="Contents_Insurance" v-if="includeContentsCover">
      <h4 class="font-20 mb-2" v-if="!$vuetify.breakpoint.mobile">
        Contents Insurance
      </h4>
      <div class="border-r10 px-3 py-9 px-lg-10">
        <h4 class="font-20 mb-2" v-if="$vuetify.breakpoint.mobile">
          Contents Insurance
        </h4>
        <div
          class="d-flex flex-column flex-lg-row align-xl-center"
          :class="$vuetify.breakpoint.mobile ? 'mb-3' : 'mb-11'"
        >
          <div
            class="d-flex flex-column flex-basis-58 mr-lg-2 left-panel__money-spinner"
          >
            <p class="mb-2 font-18 font-weight-medium">
              What amount of Contents Insurance is required?
            </p>
            <v-alert color="var(--blue-100)" class="d-none d-lg-block mb-0">
              <div class="d-flex flex-no-wrap">
                <div class="mr-1">
                  <v-icon color="var(--blue-500)">mdi-information</v-icon>
                </div>
                <div class="note__wrapper">
                  <strong>Note:</strong> The amount selected must cover the cost
                  of replacing all of your contents as new.
                </div>
              </div>
            </v-alert>
          </div>
          <BaseMoneySpinner
            :minusDataUiid="'minusDataUiid_LandlordContentsLevel'"
            :plusDataUiid="'plusDataUiid_LandlordContentsLevel'"
            :inputDataUiid="'inputDataUiid_LandlordContentsLevel'"
            :small="$vuetify.breakpoint.lgAndUp ? true : false"
            v-model="form.landlordContentsLevel.Value"
            :config="configContentsLevel"
            class="mt-3 mt-xl-0 pa-0 flex-grow-1"
          />

          <v-alert color="var(--blue-100)" class="d-block d-lg-none mt-2">
            <div class="d-flex flex-no-wrap">
              <div class="mr-1">
                <v-icon color="var(--blue-500)">mdi-information</v-icon>
              </div>
              <div class="note__wrapper">
                <strong>Note:</strong> The amount selected must cover the cost
                of replacing all of your contents as new.
              </div>
            </div>
          </v-alert>
        </div>

        <div class="d-flex flex-column flex-lg-row align-xl-center mb-11">
          <div
            class="d-flex flex-column flex-basis-58 mr-lg-2 left-panel__money-spinner"
          >
            <p class="ma-0 pr-lg-6 pr-0 font-18 font-weight-medium">
              Choose your contents cover excess
              <v-icon
                v-if="$vuetify.breakpoint.mobile"
                color="#106175"
                size="15"
                class="text-cursor"
                @click="showModal('DialogLandLordsContentCoverExcess')"
                >mdi-help-circle</v-icon
              >
            </p>
            <p
              class="align-center d-md-flex mb-0"
              v-if="!$vuetify.breakpoint.mobile"
            >
              <v-icon
                color="#106175"
                size="15"
                class="text-cursor"
                @click="showModal('DialogLandLordsContentCoverExcess')"
                >mdi-help-circle</v-icon
              >
              <a
                class="align-self-start accent--text font-weight-semi-bold"
                href="javascript:"
                @click="showModal('DialogLandLordsContentCoverExcess')"
                >What amount is right for me?</a
              >
            </p>
          </div>
          <BaseMoneySpinner
            :minusDataUiid="'minusDataUiid_ExcessContents'"
            :plusDataUiid="'plusDataUiid_ExcessContents'"
            :inputDataUiid="'inputDataUiid_ExcessContents'"
            :small="$vuetify.breakpoint.lgAndUp ? true : false"
            :config="configExcess"
            v-model="form.excessContents.Value"
            class="mt-5 mt-xl-0 pa-0 flex-grow-1"
          />
        </div>

        <div class="d-flex flex-column flex-lg-row">
          <div class="d-flex flex-column left-panel__toggle-button">
            <p class="ma-0 pr-lg-6 pr-0 font-18 font-weight-medium mb-1">
              Would you like to add extra accidental damage cover for contents?
              <v-icon
                v-if="$vuetify.breakpoint.mobile"
                color="#106175"
                size="15"
                class="text-cursor"
                @click="showModal('DialogLandLordsContentExtraAccidentalCover')"
                >mdi-help-circle</v-icon
              >
            </p>
            <span
              class="align-center d-md-flex"
              v-if="!$vuetify.breakpoint.mobile"
            >
              <v-icon
                color="#106175"
                size="15"
                class="text-cursor"
                @click="showModal('DialogLandLordsContentExtraAccidentalCover')"
                >mdi-help-circle</v-icon
              >
              <a
                class="align-self-start accent--text font-weight-semi-bold"
                color="#106175"
                href="javascript:"
                @click="showModal('DialogLandLordsContentExtraAccidentalCover')"
                >What’s covered as standard?</a
              >
            </span>
          </div>
          <div
            class="col-lg-4 pa-0 d-flex align-center mt-5 mt-lg-0 ml-lg-auto toggle-button__wrapper"
          >
            <BaseToggleButton
              :toggleButtonText="{
                yesDataUiid: 'AccidentalDamageContents_Yes',
                noDataUiid: 'AccidentalDamageContents_No',
              }"
              v-model="form.accidentalDamageContents.Value"
              :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            />
          </div>
        </div>
      </div>
    </div>

    <div>
      <h3 class="font-weight-bold mb-5 font-28">
        Would you like to boost your cover?
      </h3>
      <p :class="$vuetify.breakpoint.mobile ? 'mb-8' : 'mb-10'">
        You can choose to add optional extras to your policy to give you even
        more protection. Adding landlord’s emergency cover or legal expenses
        cover to your Landlord’s Insurance can be cheaper than getting them
        separately.
      </p>

      <div class="addOn__wrapper">
        <h4 class="font-20 mb-5">Additional cover options</h4>

        <DrawerCustomiseCoverContentAdditionalCoverOptions
          :addOns="ADD_ONS_LANDLORDS_D2C"
          :productGroup="LANDLORDS"
          :handleToggleExternal="true"
          @toggleOption="toggleAdditionalCover"
        />
      </div>

      <BaseButton
        :text="'GET QUOTES'"
        :height="'60'"
        :id="'GetQuote_btn'"
        :minWidth="$vuetify.breakpoint.lgAndUp ? '265' : '100%'"
        :color="'#fab519'"
        class="font-weight-bold font-20 rounded-pill px-10 white--text btn-quote"
        :class="'black--text'"
        :loading="isRefreshingCover"
        loadingIconColor="white"
        @click="tryGetQuote"
      />
    </div>

    <EligibilityBaseDialog
      ref="dialogEligibility"
      :windowClass="'confirm-dialog'"
    >
      <template v-slot:content="">
        <EligibilityCover
          @confirm-eligibility="onConfirmDialogEligibility"
          @cancel-eligibility="onCancelEligibility"
          @eligibility-not-meet="onOpenEligibilityNotMet"
        />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog ref="dialogNotMet" :windowClass="'confirm-dialog'">
      <template v-slot:content="">
        <EligibilityNotMetD2CLandlord
          @cancel-eligibility-not-met="cancelEligibilityNotMet"
        />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog ref="dialogLoading" :windowClass="'confirm-dialog'">
      <template v-slot:content="{ title }">
        <EligibilityLoading
          :title="title"
          :getting-quote-message="GETTING_QUOTE_LANDLORD_MESSAGE"
          :image-source="defaqtoImageUrl"
        >
        </EligibilityLoading>
      </template>
    </EligibilityBaseDialog>

    <CreateLLQuoteDialog
      v-if="showCreateQuoteDialog"
      ref="dialogCreateLLQuote"
      :insuredParty="insuredPartyAnswer.Value"
      :businessName="companyNameAnswer.Value"
      @openEligibilityDialog="openEligibilityDialog"
      @quoteTypeSelected="
        (value) =>
          (insuredPartyAnswer.Value =
            value?.toLowerCase() === LANDLORD_TYPE.Company.toLowerCase()
              ? INSURED_PARTY.Business
              : INSURED_PARTY.Individual)
      "
      @companyName="(value) => (companyNameAnswer.Value = value)"
      @cancel="() => (showCreateQuoteDialog = false)"
    >
    </CreateLLQuoteDialog>
    <EligibilityDialogWrapper
      ref="EligibilityDialogWrapper"
      @onConfirmEligibility="onConfirmEligibility"
      @confirmEligibilityNotMet="confirmEligibilityNotMet"
    />
  </div>
</template>

<script>
import {
  scrollTop,
  convertToBool,
  prepareDataForGetQuote,
  resetEligibilityCheck,
} from "@/common/utils";
import { QuestionStore } from "@/store/store";
import { dereference } from "@/common/transforms";
import { includesContents } from "@/common/answers";
import quoteService from "@/services/quote.service";
import { wordsToNumbers } from "@/common/answers.js";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import DrawerCustomiseCoverContentAdditionalCoverOptions from "@/components/QuoteResult/landlords/DrawerCustomiseCoverContentAdditionalCoverOptions.vue";

import {
  UNABLE,
  FAILED,
  INSURED_PARTY,
  LANDLORD_TYPE,
} from "@/constants/common.constants";
import { CONFIG_EXCESS_D2C } from "@/constants/excess-config.constants";
import { CONFIG_LANDLORD_CONTENTS_LEVEL } from "@/constants/contents-config.constants";
import { ROUTE_NAME } from "@/constants/route.constants";
import { COVER_DETAILS_FORM } from "@/constants/form.constants";
import { EXIT_DESTINATION } from "@/constants/common.constants";
import { DIALOG_MODULE, QUESTIONS_MODULE } from "@/store/types/module-types";
import { GETTING_QUOTE_LANDLORD_MESSAGE } from "@/constants/message.constants";

import EligibilityCover from "@/views/Dialog/EligibilityCover.vue";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import EligibilityLoading from "@/views/Dialog/EligibilityLoading.vue";
import EligibilityNotMetD2CLandlord from "@/views/Dialog/EligibilityNotMetD2CLandlord.vue";
import CreateLLQuoteDialog from "@/views/Dialog/CreateLLQuoteDialog.vue";
import EligibilityBaseDialog from "@/components/EligibilityBaseDialog.vue";
import BaseMoneySpinner from "@/components/BaseComponents/BaseMoneySpinner.vue";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton.vue";
import EligibilityDialogWrapper from "@/views/Dialog/EligibilityDialogWrapper.vue";
import { ADD_ONS_LANDLORDS_D2C } from "@/constants/additional-cover-options";
import { LANDLORDS } from "@/constants/questionset.constants";

export default {
  name: "D2CLandlordCoverDetailsPage",
  components: {
    BaseButton,
    BaseMoneySpinner,
    BaseToggleButton,
    EligibilityCover,
    EligibilityBaseDialog,
    EligibilityLoading,
    EligibilityNotMetD2CLandlord,
    CreateLLQuoteDialog,
    EligibilityDialogWrapper,
    DrawerCustomiseCoverContentAdditionalCoverOptions,
  },
  data() {
    return {
      defaqtoImageUrl: require("@/assets/images/defaqto/landlord-home-insurance.svg"),
      configExcess: CONFIG_EXCESS_D2C,
      configContentsLevel: CONFIG_LANDLORD_CONTENTS_LEVEL,
      form: COVER_DETAILS_FORM,
      isRefreshingCover: false,
      isAnnualRequote: QuestionStore.state("isAnnualRequote"),
      showCreateQuoteDialog: false,
      INSURED_PARTY,
      LANDLORD_TYPE,
      GETTING_QUOTE_LANDLORD_MESSAGE,
      ADD_ONS_LANDLORDS_D2C,
      LANDLORDS,
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isExpired", "httpConfig"]),
    ...mapState(QUESTIONS_MODULE, [
      "lastQuoteErrorType",
      "questionMap",
      "quoteAdditionalData",
      "isOriginalQuoteExpired",
      "coverAnswers",
    ]),
    ...mapActions(QUESTIONS_MODULE, ["handleD2CSaveAndExit"]),
    includeContentsCover() {
      const coverTypeValue = this.questionMap.CoverType;
      return includesContents(coverTypeValue);
    },
    quoteFailed() {
      return this.lastQuoteErrorType === FAILED;
    },
    quoteDeclined() {
      return this.lastQuoteErrorType === UNABLE;
    },
    isSelectedRentGuarantee() {
      return (
        this.form.rentGuarantee.Value && this.isConfirmedEligibilityCover()
      );
    },
    isSelectedLegalExpenses() {
      return (
        this.form.legalExpenses.Value && this.isConfirmedEligibilityCover()
      );
    },
    companyNameAnswer() {
      return this.questionMap.CompanyName;
    },
    insuredPartyAnswer() {
      return this.questionMap.InsuredParty;
    },
  },
  mounted() {
    this.getAppConfigurationContactInfo();
  },
  watch: {
    "form.accidentalDamageBuildings.Value"() {
      this.setCoverSelection({
        buildingsAd: this.form.accidentalDamageBuildings.Value,
        contentsAd: this.form.accidentalDamageContents.Value,
      });
    },
    "form.accidentalDamageContents.Value"() {
      this.setCoverSelection({
        buildingsAd: this.form.accidentalDamageBuildings.Value,
        contentsAd: this.form.accidentalDamageContents.Value,
      });
    },
  },
  beforeMount() {
    this.initDataFromQuoteResponse();
    scrollTop();
    this.setRestoringLastStep(false);
  },
  beforeRouteLeave(to, _from, next) {
    if (
      [
        ROUTE_NAME.LANDLORDS.D2C.PROPERTY_DETAILS,
        ROUTE_NAME.LANDLORDS.D2C.YOUR_DETAILS,
      ].includes(to.name)
    ) {
      prepareDataForGetQuote(this.form, this.questionMap);
      resetEligibilityCheck(this.form);
    }
    next();
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "getQuotes",
      "getAppConfigurationContactInfo",
      "contactInfo",
      "saveProgress",
      "setIsExpiredFlag",
      "setCoverSelection",
      "setCoverAnswers",
      "setRestoringLastStep",
      "toggleGlobalSaveAndExitDialog",
    ]),
    ...mapMutations(DIALOG_MODULE, ["showModal"]),

    openEligibilityDialog(showCompanyInput) {
      this.showCreateQuoteDialog = false;
      if (showCompanyInput == false) {
        this.$refs.EligibilityDialogWrapper?.$refs.dialogEligibilityLandLord.open(
          "Eligibility check"
        );
      } else {
        this.$refs.EligibilityDialogWrapper?.$refs.dialogEligibilityLandLordCompany.open(
          "Eligibility check"
        );
      }
    },

    async onConfirmEligibility(productId, landLordType) {
      this.setInsuredPartyAnswers(
        this.questionMap,
        landLordType,
        this.companyNameAnswer.Value
      );
      this.questionMap.LandlordsEligibility.Value = true;
      const hasRpOrLe =
        this.form.rentGuarantee?.Value || this.form.legalExpenses?.Value;
      // Default to false (not a new let) when user hasn't explicitly answered.
      // This applies the 90-day exclusion clause, which is the safe/conservative default.
      if (
        hasRpOrLe &&
        !this.questionMap.NewLetOrProductTransfer.Value &&
        this.questionMap.NewLetOrProductTransfer.Value !== false
      ) {
        this.questionMap.NewLetOrProductTransfer.Value = false;
        this.questionMap.NewLetOrProductTransfer.Source = "User";
      }

      const request = {
        QuoteAccessId: this.quoteAdditionalData.QuoteAccessId,
        InsuredParty: this.insuredPartyAnswer.Value,
        CompanyName: this.companyNameAnswer.Value,
        IsExpiredQuoteConfirmed: this.isOriginalQuoteExpired,
      };

      await quoteService.confirmEligibility(request, this.httpConfig);
      this.quoteAdditionalData.IsEligibilityConfirmed = true;
      this.quoteAdditionalData.IsExpiredQuoteConfirmed =
        this.isOriginalQuoteExpired;
      this.quoteAdditionalData.InsuredParty = request.InsuredParty;
      this.quoteAdditionalData.CompanyName = request.CompanyName;
      this.isAnnualRequote = false;

      this.getQuote();
    },

    setInsuredPartyAnswers(questionMap, insuredPartyType, companyName) {
      if (insuredPartyType === LANDLORD_TYPE.Company) {
        questionMap.InsuredParty.Value = INSURED_PARTY.Business;
        questionMap.CompanyName.Value = companyName;
      } else {
        questionMap.InsuredParty.Value = INSURED_PARTY.Individual;
        questionMap.CompanyName.Value = "";
      }
    },

    tryGetQuote() {
      if (
        (!this.quoteAdditionalData.IsEligibilityConfirmed &&
          this.isAnnualRequote) ||
        (!this.quoteAdditionalData.IsExpiredQuoteConfirmed &&
          this.isOriginalQuoteExpired)
      ) {
        this.showCreateQuoteDialog = true;
        return;
      }
      this.getQuote();
    },

    getQuote() {
      if (this.isRefreshingCover) return;
      this.questionMap.LandlordsEligibility.Value = true;
      if (!this.form.rentGuarantee?.Value && !this.form.legalExpenses?.Value) {
        this.questionMap.NewLetOrProductTransfer.Value = "";
        const keysToRemove = [
          "LegalExpenses",
          "RentGuarantee",
          "AddOnEligibility",
          "NewLetOrProductTransfer",
        ];
        this.setCoverAnswers(
          this.coverAnswers.filter(
            (a) => !keysToRemove.includes(a.InterfaceKey)
          )
        );
      } else if (
        this.questionMap.NewLetOrProductTransfer.Value !== true &&
        this.questionMap.NewLetOrProductTransfer.Value !== false
      ) {
        // Default to false (not a new let) when user hasn't explicitly answered.
        // This applies the 90-day exclusion clause, which is the safe/conservative default.
        this.questionMap.NewLetOrProductTransfer.Value = false;
        this.questionMap.NewLetOrProductTransfer.Source = "User";
      }
      this.isRefreshingCover = true;
      this.$refs.dialogLoading.open("Hang tight, getting quotes...");
      const quoteRequestFields = {
        IsPartialQuote: false,
      };

      this.prepareDataForSubmit();

      this.getQuotes(quoteRequestFields)
        .then(() => {
          this.isRefreshingCover = false;
          this.setIsExpiredFlag(false);
          this.$refs.dialogLoading.cancel();
          this.$router.push({
            name: ROUTE_NAME.LANDLORDS.D2C.QUOTATION_RESULT,
          });
        })
        .catch(() => {
          this.isRefreshingCover = false;
          this.$refs.dialogLoading.cancel();
        });
    },

    saveAndExit() {
      this.prepareDataForSubmit();
      this.toggleGlobalSaveAndExitDialog(EXIT_DESTINATION.landlordWelcomePage);
    },

    prepareDataForSubmit() {
      prepareDataForGetQuote(this.form, this.questionMap);
      resetEligibilityCheck(this.form);
    },

    backToPropertyDetail() {
      this.$router.push({ name: ROUTE_NAME.LANDLORDS.D2C.PROPERTY_DETAILS });
    },

    initDataFromQuoteResponse() {
      this.form.accidentalDamageBuildings =
        this.questionMap.AccidentalDamageBuildings;
      if (this.form.accidentalDamageBuildings) {
        this.form.accidentalDamageBuildings.Value = convertToBool(
          this.form.accidentalDamageBuildings.Value
        );
      }

      this.form.excessBuildings = dereference(this.questionMap.ExcessBuildings);
      if (!this.form.excessBuildings.Value) {
        this.form.excessBuildings.Value = this.configExcess.default;
      } else {
        this.form.excessBuildings.Value = wordsToNumbers(
          this.form.excessBuildings.Value
        );
      }

      if (this.includeContentsCover) {
        this.form.landlordContentsLevel = dereference(
          this.questionMap.LandlordContentsLevel
        );
        if (!this.form.landlordContentsLevel.Value) {
          this.form.landlordContentsLevel.Value =
            this.configContentsLevel.default;
        } else {
          this.form.landlordContentsLevel.Value = wordsToNumbers(
            this.form.landlordContentsLevel.Value
          );
        }

        this.form.excessContents = dereference(this.questionMap.ExcessContents);
        if (!this.form.excessContents.Value) {
          this.form.excessContents.Value = this.configExcess.default;
        } else {
          this.form.excessContents.Value = wordsToNumbers(
            this.form.excessContents.Value
          );
        }

        this.form.accidentalDamageContents = dereference(
          this.questionMap.AccidentalDamageContents
        );
        if (this.form.accidentalDamageContents) {
          this.form.accidentalDamageContents.Value = convertToBool(
            this.form.accidentalDamageContents.Value
          );
        }
      }

      this.form.rentGuarantee = this.questionMap.RentGuarantee;
      if (this.form.rentGuarantee) {
        this.form.rentGuarantee.Value = convertToBool(
          this.form.rentGuarantee.Value
        );
      }
      this.form.legalExpenses = this.questionMap.LegalExpenses;
      if (this.form.legalExpenses) {
        this.form.legalExpenses.Value = convertToBool(
          this.form.legalExpenses.Value
        );
      }
      this.form.landlordsEmergency = this.questionMap.LandlordsEmergency;
      if (this.form.landlordsEmergency) {
        this.form.landlordsEmergency.Value = convertToBool(
          this.form.landlordsEmergency.Value
        );
      }

      this.form.addonEligibility = this.questionMap.AddOnEligibility;
    },

    onConfirmDialogEligibility(newLetOrProductTransfer) {
      this.form.addonEligibility.Value = true;
      this.questionMap.NewLetOrProductTransfer.Value = newLetOrProductTransfer;
      this.questionMap.NewLetOrProductTransfer.Source = "User";
      this.saveProgress();
      this.$refs.dialogEligibility.cancel();
    },

    toggleAdditionalCover(option) {
      const cover = option.formControl;
      this.form[cover].Value = !this.form[cover].Value;
      this.updateIsAdded(cover, this.form[cover].Value);
      if (
        !this.isConfirmedEligibilityCover() &&
        cover !== "landlordsEmergency"
      ) {
        this.$refs.dialogEligibility.open("Eligibility check");
        return;
      }
    },
    updateIsAdded(formControl, value) {
      this.ADD_ONS_LANDLORDS_D2C = this.ADD_ONS_LANDLORDS_D2C.map((item) =>
        item.formControl === formControl ? { ...item, isAdded: value } : item
      );
    },
    onCancelEligibility() {
      this.resetAdditionalCover();
      this.$refs.dialogEligibility.cancel();
      return;
    },

    onOpenEligibilityNotMet() {
      this.$refs.dialogEligibility.cancel();
      this.$refs.dialogNotMet.open();
      return;
    },

    cancelEligibilityNotMet() {
      this.resetAdditionalCover();
      this.$refs.dialogNotMet.cancel();
      return;
    },

    isConfirmedEligibilityCover() {
      const isConfirmed = this.form.addonEligibility.Value;
      return isConfirmed;
    },

    confirmEligibilityNotMet() {
      this.prepareDataForSubmit();
      this.saveProgress();
      this.$refs.dialogNotMet.cancel();
      this.$router.push({ name: ROUTE_NAME.LANDLORDS.D2C.LANDING_PAGE });
    },

    resetAdditionalCover() {
      this.form.rentGuarantee.Value = false;
      this.form.legalExpenses.Value = false;
      this.form.addonEligibility.Value = null;
      this.questionMap.NewLetOrProductTransfer.Value = "";
      this.updateIsAdded("legalExpenses", false);
      this.updateIsAdded("rentGuarantee", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/d2c/cover-detail.scss";
</style>
